import { render, staticRenderFns } from "./HandbookSpecies.vue?vue&type=template&id=614ec9bd&lang=pug&"
import script from "./HandbookSpecies.vue?vue&type=script&lang=ts&"
export * from "./HandbookSpecies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports